import Axios from "axios";
import {
  SET_PROJECT_LIST,
  UNSET_PROJECT_LIST,
} from "@/store/mutation-types";
import {
  saveUpdateProject, getProjectList, getProjectListbyId as getProjectListbyIdApi, getProjectActivityLogById, saveUpdateProjectDetail} from "@/store/api";

const state = {
  getProjectList: [],
  editingProject: null,
  viewingProjects: null,
};

const getters = {
  getProjectList(state) {
    return state.getProjectList;
  },
  getEditingProject: (state) => state.editingProject,
  getViewingProjects: (state) => state.viewingProjects,
};

const mutations = {
  [SET_PROJECT_LIST](state, data) {
    state.getProjectList = data;
  },
  [UNSET_PROJECT_LIST](state) {
    state.getProjectList = [];
  },
  setEditingProject(state, project) {
    state.editingProject = project;
  },
  setViewingProjects(state, project) {
    state.viewingProjects = project;
  },
};

const actions = {
  saveUpdateProject({ commit }, data) {
    commit("SET_LOADING", { color: "primary" });
    return new Promise((resolve, reject) => {
      Axios.post(saveUpdateProject, data)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          reject(error);
        })
        .then((always) => {
          commit("UNSET_LOADING");
        });
    });
  },

  getProjectList({ commit }) {
    return new Promise((resolve, reject) => {
      Axios.post(getProjectList)
        .then(function (response) {
          commit("SET_PROJECT_LIST", response.data.data);
          resolve(response);
        })
        .catch(function (error) {
          commit("UNSET_PROJECT_LIST");
          reject(error);
        })
        .then((always) => {});
    });
  },

  getProjectListById({ commit }, data) {
    const getProjectListById = `${getProjectListbyIdApi}/${data}`;
    commit("SET_LOADING", { color: "primary" });
    return new Promise((resolve, reject) => {
      Axios.get(getProjectListById)
        .then((response) => {
          resolve(response.data.data);
        })
        .catch((error) => {
          console.error("API Error:", error.response?.data || error.message);
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING");
        });
    });
  },

  getProjectActivityLogById({ commit }, data) {
      const getProjectActivityLogByIdApi = `${getProjectActivityLogById}/${data}`;
      commit("SET_LOADING", { color: "primary" });
      return new Promise((resolve, reject) => {
        Axios.get(getProjectActivityLogByIdApi)
          .then((response) => {
              resolve(response.data.data);
          })
          .catch((error) => {
              reject(error);
          })
          .finally(() => {
              commit("UNSET_LOADING")
          });
      });
  },

  saveUpdateProjectDetail({ commit }, {id, data}) {
    commit("SET_LOADING", { color: "primary" });
    return new Promise((resolve, reject) => {
      Axios.post(`${saveUpdateProjectDetail}/${id}`, data)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          reject(error);
        })
        .then((always) => {
          commit("UNSET_LOADING");
        });
    });
  },

};

export default {
  state,
  getters,
  actions,
  mutations,
};
